import { render, staticRenderFns } from "./OrdenesCompraListado.vue?vue&type=template&id=2f42411c"
import script from "./OrdenesCompraListado.vue?vue&type=script&lang=js"
export * from "./OrdenesCompraListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports